<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <barcode-form> </barcode-form>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-xl-12 col-lg-11 col-md-10">
        <bar-printed></bar-printed>
      </div>
    </div> -->
  </div>
</template>
<script>
import BarcodeForm from "./Barcode/BarcodeForm.vue";
//import BarPrinted from "@/pages/BarPrinted.vue";
export default {
  components: {
    BarcodeForm
  },
};
</script>
<style>
</style>